import dynamic from "next/dynamic";
const VideoBanner = dynamic(
  import("../components/molecules/videoBanner/VideoBanner"),
  { ssr: true }
);
const AppBanner = dynamic(
  import("../components/molecules/appBanner/AppBanner"),
  { ssr: true }
);
const UspContainer = dynamic(
  import("../components/molecules/UspContainer/UspContainer"),
  { ssr: true }
);
const HomeBanner = dynamic(
  import("../components/molecules/homeBanner/HomeBanner"),
  { ssr: true }
);
const PromotionBanner = dynamic(
  import("../components/molecules/promotionContainer/PromotionContainer"),
  { ssr: true }
);
const TestimonialCarousel = dynamic(
  import("../components/organisms/testimonialCarousel/TestimonialCarousel"),
  { ssr: true }
);
const TwoColumnImage = dynamic(
  import("../components/molecules/twoColumnImage/TwoColumnImage"),
  { ssr: true }
);
const MultiLayoutProposition = dynamic(
  import(
    "../components/molecules/multiLayoutProposition/MultiLayoutProposition"
  ),
  { ssr: true }
);
const NumericCounter = dynamic(
  import("../components/organisms/numericCounter/NumericCounter"),
  { ssr: true }
);
const AccordionContainer = dynamic(
  import("../components/molecules/AccordionContainer/AccordionContainer"),
  { ssr: true }
);
const ServiceCardGroup = dynamic(
  import("../components/organisms/ServiceCard/ServiceCardGroup"),
  { ssr: true }
);
const CountDownBanner = dynamic(
  import("../components/molecules/countDownBanner/CountDownBanner"),
  { ssr: true }
);
const InternationalCallingDropdown = dynamic(
  import(
    "../components/molecules/internationalCallingDropdown/InternationalCallingDropdown"
  ),
  { ssr: true }
);
const InfoContainer = dynamic(
  import("../components/molecules/InfoContainer/InfoContainer"),
  { ssr: true }
);
const PanoramaImage = dynamic(
  import("../components/atoms/panoramaImage/PanoramaImage"),
  { ssr: true }
);
const BreadCrumb = dynamic(
  import("../components/atoms/breadCrumb/BreadCrumb"),
  { ssr: true }
);
const FibreSearchBanner = dynamic(
  import("../components/molecules/fibreSearchBanner/FibreSearchBanner"),
  { ssr: true }
);
const QuickLink = dynamic(
  import("../components/molecules/quickLink/QuickLink"),
  { ssr: true }
);
import HeroCarousel from "../components/molecules/HeroCarousel/HeroCarousel";
import DealCatalog from "../components/organisms/DealCatalog/DealCatalog";
import ProductCatalog from "../components/organisms/productCatalog/ProductCatalog";
import ImageCard from "../components/molecules/imageCard/ImageCard";
import SpecialProduct from "../components/molecules/specialProduct/SpecialProduct";
import HomePageHeading from "../components/molecules/homePageHeading/homePageHeading";
import HomeSlider from "../components/molecules/homeSlider/HomeSlider";
import HomeTabs from "../components/molecules/homeTabs/HomeTabs";
import ProductCarousel from "../components/molecules/ProductCarousel/ProductCarousel";
import StepProcess from "../components/organisms/stepProcess/StepProcess";
import SmallCardsCarousel from "../components/molecules/SmallCardsCarousel/SmallCardsCarousel";
import FourQuadInteractive from "../components/organisms/FourQuadInteractive/FourQuadInteractive";
import {
  Container,
  CustomContainer,
} from "../components/atoms/DependencyHelper";
import { formatBreadCrumb } from "../utils/helperServices";
import config from "../config/index";

export const renderComponent = (component, key, analyticsData = {}) => {
  let toRender;

  switch (component.type) {
    case "breadcrumbs": {
      toRender = (
        <Container
          id={component.id}
          fluid
          key={component.type + key}
          data-cms-title={component.analyticTitle}
          className={` ${
            component.title == "International calling breadcrumb" &&
            "container-roaming"
          }`}
        >
          <Container>
            <BreadCrumb list={formatBreadCrumb(component.items)} />
          </Container>
        </Container>
      );
      break;
    }
    case "multi_column_usp": {
      toRender = (
        <Container
          id={component.id}
          key={component.type + key}
          data-cms-title={component.analyticTitle}
          className="py-l"
          fluid
        >
          <HomePageHeading
            secondaryGreyText={component.title}
            alignment={component?.heading_position}
            container
            titleType={component.titleType}
          />
          <UspContainer uspItems={component} />
        </Container>
      );
      break;
    }
    case "deal_catalog": {
      toRender = (
        <Container
          fluid
          key={component.type + key}
          className="py-l"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <DealCatalog
            component={component}
            analyticsData={analyticsData}
            campaignFlag={true}
          />
        </Container>
      );
      break;
    }
    case "product_catalog": {
      toRender = (
        <Container
          fluid
          key={component.type + key}
          className="py-l"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <ProductCatalog component={component} analyticsData={analyticsData} />
        </Container>
      );
      break;
    }
    case "carousel": {
      toRender = (
        <Container
          key={component.type + key}
          fluid
          className="overflow-hidden"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <HeroCarousel
            slides={component.items}
            btnVariant={component.buttonStyle}
            carouselBtnVariant={component?.carouselButtonStyle}
            id={component.id}
          />
        </Container>
      );
      break;
    }
    case "portlet": {
      toRender = renderPortlet(component, key);
      break;
    }
    case "product_card":
    case "image_card": {
      toRender = imageCardSlider(component, key, analyticsData);
      break;
    }
    case "four_column_usp": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <HomePageHeading
            secondaryGreyText={component.title}
            alignment={component?.heading_position}
            container
          />
          <UspContainer uspItems={component} />
        </Container>
      );
      break;
    }
    case "banner": {
      toRender = (
        <Container
          key={component.type + key}
          fluid
          className="py-l overflow-hidden px-0"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <HomePageHeading
            text={component.bannerTitle}
            secondaryText={component.bannerSubTitle}
            mainHeadingRequired={true}
            alignment={component?.heading_position}
            container
          />
          <HomeBanner
            desktopImage={component.bannerImage}
            mobileImage={component.bannerMobileImage}
            ctaLabel={component.callToActionLabel}
            ctaLink={component.callToActionUrl}
            btnVariant={component.buttonStyle}
            isOpenNewTab={component.isOpenNewTab}
            id={component.id ? component.id : ""}
          />
        </Container>
      );
      break;
    }
    case "appstore_banner": {
      toRender = (
        <Container
          key={component.type + key}
          className="py-l overflow-hidden"
          fluid
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <HomePageHeading
            text={component.title}
            secondaryText={component.heading}
            mainHeadingRequired={true}
            alignment={component?.heading_position}
          />
          <AppBanner
            icon={component.icon}
            description={component.description}
            buttons={component.buttonItems}
            desktopImage={component.backgroundImage}
            mobileImage={component.backgroundImageMobile}
            imageApp={component.image}
            buttonsVariant={component.buttonStyle}
            imageMobile={component.imageMobile ? component.imageMobile : ""}
          />
        </Container>
      );
      break;
    }
    case "horizontal_video":
    case "video_with_cta": {
      toRender = (
        <Container
          key={component.type + key}
          className="py-l"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <HomePageHeading
            text={component.title}
            secondaryText={component.description}
            mainHeadingRequired={true}
            alignment={component?.heading_position}
          />
          {renderVideo(component, true)}
        </Container>
      );
      break;
    }
    case "promotion_container": {
      toRender = (
        <Container
          fluid
          key={component.type + key}
          className="promotion_container"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <PromotionBanner metaData={component} variant="roaming" />
        </Container>
      );
      break;
    }
    case "multi_column_card": {
      toRender = (
        <Container
          key={component.type + key}
          className="py-l px-0"
          id={component.id}
          data-cms-title={component.analyticTitle}
          fluid
        >
          <ServiceCardGroup
            alignment={component?.heading_position}
            cards={component.items}
            cardType="service"
            heading={component.title}
            className="justify-content-center"
          />
        </Container>
      );
      break;
    }
    case "3_column_plain_cards": {
      toRender = (
        <Container
          key={component.type + key}
          className="py-l"
          id={component.id}
          data-cms-title={component.analyticTitle}
          fluid
        >
          <ServiceCardGroup
            cards={component.cards}
            cardType="plain"
            heading={component.componentTitle}
            customStyle
          />
        </Container>
      );
      break;
    }
    case "paragraph": {
      toRender = (
        <Container
          key={component.type + key}
          className="pt-l pb-xs container pt-32"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <InfoContainer component={component} />
        </Container>
      );
      break;
    }
    case "two_column_proposition": {
      toRender = (
        <Container
          key={component.type + key}
          className="py-l"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <TwoColumnImage metaData={component} />
        </Container>
      );
      break;
    }
    case "calling_costs": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          data-cms-title={component.analyticTitle}
          className="pb-l"
          fluid
        >
          <InternationalCallingDropdown data={component} />
        </Container>
      );
      break;
    }
    case "numerical_counter": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <HomePageHeading
            secondaryText={component.title}
            alignment={component?.heading_position}
          />
          <NumericCounter numericCounterData={component} />
        </Container>
      );
      break;
    }
    case "countdown_banner": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          fluid
          data-cms-title={component.analyticTitle}
        >
          <CountDownBanner countDownBannerData={component} />
        </Container>
      );
      break;
    }
    case "check_coverage_banner": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          fluid
          data-cms-title={component.analyticTitle}
        >
          <FibreSearchBanner fibreSearchBannerData={component} />
        </Container>
      );
      break;
    }
    case "quicklinks": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          fluid
          data-cms-title={component.analyticTitle}
        >
          <QuickLink quickLinkData={component} />
        </Container>
      );
      break;
    }
    case "testimonial_carousel": {
      toRender = (
        <Container
          key={component.type + key}
          className="py-l overflow-hidden"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <TestimonialCarousel items={component.items} />
        </Container>
      );
      break;
    }
    case "multi_column_proposition": {
      toRender = (
        <Container
          key={component.type + key}
          className="py-l"
          id={component.id}
          data-cms-title={component.analyticTitle}
          fluid
        >
          <MultiLayoutProposition metaData={component} />
        </Container>
      );
      break;
    }

    case "multi_quadrant_proposition": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          className="py-l"
          data-cms-title={component.analyticTitle}
          fluid
        >
          <MultiLayoutProposition metaData={component} />
        </Container>
      );
      break;
    }

    case "product_carousel": {
      toRender = (
        <ProductCarousel
          ProductCarouselData={component.products}
          key={component.type + key}
          id={component.id}
          data-cms-title={component.analyticTitle}
          width="15.5rem"
          img_width="11.25rem"
          img_height="11.25rem"
          width_mobile="10.375rem"
          img_width_mobile="8.375rem"
          img_height_mobile="8.375rem"
        />
      );
      break;
    }
    case "accordion": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          data-cms-title={component.analyticTitle}
          className="py-l"
        >
          <AccordionContainer
            faqSections={component.faqs}
            componentTitle={component.componentTitle}
            componentDescription={component.componentDescription}
            alignment={component?.heading_position}
          />
        </Container>
      );
      break;
    }

    case "123_process_image": {
      toRender = (
        <Container
          key={component.type + key}
          className="py-l"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <StepProcess metaData={component} />
        </Container>
      );
      break;
    }
    case "multi_quadrant_phone_visual": {
      toRender = (
        <CustomContainer
          key={component.type + key}
          className="py-l"
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <FourQuadInteractive content={component.items} data={component} />
        </CustomContainer>
      );
      break;
    }
    case "panoramic_image": {
      toRender = (
        <Container
          key={component.type + key}
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <PanoramaImage data={component} />
        </Container>
      );
      break;
    }
    case "small_card_image_carousel": {
      toRender = (
        <CustomContainer
          className="py-l"
          key={component.type + key}
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <SmallCardsCarousel
            data={component}
            type={component.type}
            width="100%"
            height="11.25rem"
            mobile_width="18.5625rem"
            mobile_height="11.25rem"
            analyticsData={{ link_type: "o", ...analyticsData }}
          />
        </CustomContainer>
      );
      break;
    }
    case "grid_carousel": {
      toRender = (
        <CustomContainer
          key={component.type + key}
          id={component.id}
          data-cms-title={component.analyticTitle}
        >
          <SmallCardsCarousel
            data={component}
            type={component.type}
            width="100%"
            height="15rem"
            mobile_width="19.6875rem"
            mobile_height="12.5rem"
            hideCarousel={true}
            smallTitle={true}
          />
        </CustomContainer>
      );
      break;
    }
    default:
      console.log("could not render component", component.type);
  }
  return toRender;
};

export const renderPortlet = (component, key) => {
  const tabs = Object.keys(component.items);
  const totalTabs = tabs.length;
  const generateHotSpot = (left, top, heading, description, placement) => {
    if (left && top && placement) {
      return [
        {
          tip: {
            placement,
            heading,
            description,
          },
          left,
          top,
        },
      ];
    }
    return [];
  };
  const specialProductSlider = (special, index) => (
    <SpecialProduct
      tagLabel={special.badgeLabel}
      tagVariant={special.badgeStyle}
      key={index}
      heading={special.title}
      description={special.description}
      additionals={special.addOn}
      ctaLabel={special.callToActionLabel}
      ctaLink={special.callToActionUri}
      isOpenNewTab={special?.isOpenNewTab}
      imgUrl={special.image}
      videoUrl={special.videoUrl}
      hotSpots={generateHotSpot(
        special.left,
        special.top,
        special.imageHeading,
        special.imageDescription,
        special.placement
      )}
      price={special.fromLabel}
      type={special.type}
      id={special.id}
      data-cms-title={
        special.analyticTitle ? special.analyticTitle : special.title
      }
      variant={component.buttonStyle}
    />
  );
  if (totalTabs > 1) {
    const tabsToRender = [];
    for (let i = 0; i < totalTabs; i++) {
      tabsToRender.push({
        title: tabs[i],
        component: (
          <HomeSlider slideItems={component.items[tabs[i]]}>
            {specialProductSlider}
          </HomeSlider>
        ),
      });
    }
    return (
      <Container
        fluid
        key={component.type + key}
        className="py-l overflow-hidden"
        id={component.id}
        data-cms-title={component.analyticTitle}
      >
        <HomePageHeading
          text={component.title}
          mainHeadingRequired={true}
          alignment={component?.heading_position}
          container
        />
        <HomeTabs
          tabsContent={tabsToRender}
          variant={component.tabStyle}
          tabType={component.tabType}
          alignment={component?.heading_position}
        ></HomeTabs>
      </Container>
    );
  } else {
    const tabs = Object.keys(component.items);
    return (
      <Container
        fluid
        key={component.type + key}
        className="py-l overflow-hidden"
        id={component.id}
        data-cms-title={component.analyticTitle}
      >
        <HomePageHeading
          text={component.title}
          secondaryText={tabs[0]}
          className="explore-our-section"
          mainHeadingRequired={true}
          alignment={component?.heading_position}
          container
        />
        <HomeSlider slideItems={component.items[tabs[0]]}>
          {specialProductSlider}
        </HomeSlider>
      </Container>
    );
  }
};

export const imageCardSlider = (component, key, analyticsData) => {
  const tabs = !Array.isArray(component.items) && Object.keys(component.items);
  const totalTabs = tabs.length;
  const cardType = component.imageCardType == "2*3" ? "two-third" : "";
  const imageCardSlider = (card, index, array, type) => (
    <ImageCard
      title={card?.title}
      description={card?.description}
      image={card?.image}
      icon={card?.icon}
      ctaLink={card?.callToActionUri}
      ctaLabel={card?.callToActionLabel}
      type={type}
      key={index}
      id={card?.id}
      ctaVariant={component?.buttonStyle}
      isOpenNewTab={card?.isOpenNewTab}
      dataCMSTitle={card?.analyticTitle ? card?.analyticTitle : card?.title}
      analyticsData={{
        link_type: "o",
        link_name: `${analyticsData?.page_name}: promo: p${index + 1}: ${
          card?.title ? card?.title.toLowerCase() : ""
        }: ${component?.title ? component?.title.toLowerCase() : ""}`,
        ...analyticsData,
      }}
    />
  );
  if (totalTabs > 1) {
    const tabsToRender = [];
    for (let i = 0; i < totalTabs; i++) {
      tabsToRender.push({
        title: tabs[i],
        component: (
          <HomeSlider
            slideItems={component.items[tabs[i]]}
            type={cardType}
            className={component.type === "product_card" && "product_card"}
          >
            {imageCardSlider}
          </HomeSlider>
        ),
      });
    }
    return (
      <Container
        fluid
        key={component.type + key}
        className="py-l overflow-hidden"
        id={component.id}
        data-cms-title={component.analyticTitle}
      >
        <HomePageHeading
          text={component.title}
          className="explore-our-section"
          mainHeadingRequired={true}
          alignment={component?.heading_position}
        />
        <HomeTabs
          tabsContent={tabsToRender}
          variant={component.tabStyle}
          tabType={component.tabType}
          alignment={component?.heading_position}
        ></HomeTabs>
      </Container>
    );
  } else if (totalTabs == 1) {
    const tabs = Object.keys(component.items);
    return (
      <Container
        fluid
        key={component.type + key}
        className="py-l overflow-hidden"
        id={component.id}
        data-cms-title={component.analyticTitle}
      >
        <HomePageHeading
          text={component.title}
          secondaryText={tabs[0]}
          mainHeadingRequired={true}
          alignment={component?.heading_position}
        />
        <HomeSlider
          slideItems={component.items[tabs[0]]}
          type={cardType}
          className={component.type === "product_card" && "product_card"}
        >
          {imageCardSlider}
        </HomeSlider>
      </Container>
    );
  } else {
    return (
      <Container
        fluid
        key={component.type + key}
        className="py-l overflow-hidden"
        id={component.id}
        data-cms-title={component.analyticTitle}
      >
        <HomePageHeading
          secondaryText={component.title}
          textClassName={component.type === "product_card" && "product_card"}
          mainHeadingRequired={true}
          alignment={component?.heading_position}
        />
        <HomeSlider
          slideItems={component.items}
          type={cardType}
          className={component.type === "product_card" && "product_card"}
        >
          {imageCardSlider}
        </HomeSlider>
      </Container>
    );
  }
};

export const renderVideo = (
  component,
  setState,
  width = "1284",
  height = "552"
) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const generateVideoSrc = videoUrl => {
    if (videoUrl.indexOf("//www.youtube.com/") !== -1) {
      return {
        techOrder: ["youtube"],
        sources: [{ type: "video/youtube", src: videoUrl }],
      };
    }
    return {
      sources: [{ type: "video/mp4", src: videoUrl }],
    };
  };
  return (
    <VideoBanner
      metaData={component}
      config={Object.assign(
        { setInitialState: setState },
        {
          autoplay: false,
          controls: true,
          aspectRatio: `${width}:${height}`,
          preload: "auto",
          poster: component.thumbnail,
          icon: `${imagePrefix}/assets/images/video-banner-play-icon.svg`,
        },
        generateVideoSrc(component.video)
      )}
    />
  );
};
